/* XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX */
/* AUTO-GENERATED; DO NOT EDIT! (edit routegen.js instead) */
/* XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX */

import AboutUs from "./p/AboutUs";
import Achievements from "./p/Achievements";
import BeginnersGuide from "./p/BeginnersGuide";
import Contact from "./p/Contact";
import Cookies from "./p/Cookies";
import EditGame from "./p/EditGame";
import ExploreBANK from "./p/ExploreBANK";
import ExploreCOMM from "./p/ExploreCOMM";
import ExploreCPH from "./p/ExploreCPH";
import ExploreCRYPTO from "./p/ExploreCRYPTO";
import ExploreHEL from "./p/ExploreHEL";
import ExploreICE from "./p/ExploreICE";
import ExploreMarkets from "./p/ExploreMarkets";
import ExploreSTO from "./p/ExploreSTO";
import ExploreUS from "./p/ExploreUS";
import ExploreWBAG from "./p/ExploreWBAG";
import ExploreXETRA from "./p/ExploreXETRA";
import FAQ from "./p/FAQ";
import Game from "./p/Game";
import Games from "./p/Games";
import InvitePage from "./p/InvitePage";
import Logout from "./p/Logout";
import NewGame from "./p/NewGame";
import Notifications from "./p/Notifications";
import Partners from "./p/Partners";
import PasswordReset from "./p/PasswordReset";
import Portfolio from "./p/Portfolio";
import Preferences from "./p/Preferences";
import PrivacyPolicy from "./p/PrivacyPolicy";
import RenderOpenGraphTicker from "./p/RenderOpenGraphTicker";
import TermsOfUse from "./p/TermsOfUse";
import Ticker from "./p/Ticker";
import TradeHistory from "./p/TradeHistory";
import Unsubscribe from "./p/Unsubscribe";
import VerifyEmail from "./p/VerifyEmail";

import { Main, MainNoNagbox } from "./Main";
import { Home, Welcome } from "./p/Home";
import { DefaultLeaderboard } from "./p/Leaderboard";

export default {
	"/": {
		"": Home,
		"/achievements": Achievements,
		"/edit_game/:game_id": EditGame,
		"/explore": ExploreMarkets,
		"/explore-bank": ExploreBANK,
		"/explore-commodities": ExploreCOMM,
		"/explore-cph": ExploreCPH,
		"/explore-crypto": ExploreCRYPTO,
		"/explore-hel": ExploreHEL,
		"/explore-ice": ExploreICE,
		"/explore-sto": ExploreSTO,
		"/explore-us": ExploreUS,
		"/explore-vie": ExploreWBAG,
		"/explore-xetra": ExploreXETRA,
		"/game/:game_id": Game,
		"/games": Games,
		"/invite/:game_id": InvitePage,
		"/invite/:game_id/:invite_key": InvitePage,
		"/logout": Logout,
		"/new_game": NewGame,
		"/notifications": Notifications,
		"/password_reset": PasswordReset,
		"/portfolio/:portfolio_id": Portfolio,
		"/preferences": Preferences,
		"/ticker/:exchange/:ticker": Ticker,
		"/trade_history": TradeHistory,
		"/unsub": Unsubscribe,
		"/welcome": Welcome,
		container: Main,
	},
	"/_render": {
		"/opengraph": {
			"/ticker/:exchange/:ticker": RenderOpenGraphTicker,
		},
	},
	"/about": {
		"": AboutUs,
		container: MainNoNagbox,
	},
	"/contact": {
		"": Contact,
		container: MainNoNagbox,
	},
	"/cookies": {
		"": Cookies,
		container: MainNoNagbox,
	},
	"/equity-abc": {
		"": BeginnersGuide,
		container: MainNoNagbox,
	},
	"/faq": {
		"": FAQ,
		container: MainNoNagbox,
	},
	"/leaderboard": {
		"/:data_key": DefaultLeaderboard,
	},
	"/partners": {
		"": Partners,
		container: MainNoNagbox,
	},
	"/privacy": {
		"": PrivacyPolicy,
		container: MainNoNagbox,
	},
	"/termsofuse": {
		"": TermsOfUse,
		container: MainNoNagbox,
	},
	"/verify_email": {
		"": VerifyEmail,
		container: MainNoNagbox,
	},
};



// WEBPACK FOOTER //
// ./src/routes.autogen.js